import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["date", "time"]

  connect() {
    this.update()
    this.timer = setInterval(() => this.update(), 1000)
  }

  disconnect() {
    clearInterval(this.timer)
  }

  update() {
    const now = new Date()
    this.dateTarget.textContent = now.toLocaleDateString(undefined, { day: "2-digit", month: "short", year: "numeric" })
    this.timeTarget.textContent = now.toLocaleTimeString(undefined, { hour: "2-digit", minute: "2-digit", second: "2-digit" })
  }
}
